import EosRpc from '@/api/eosrpc'

export default {
  namespaced: true,
  state: {
    transactions: [],
    currentPage: 1,
    maxTransactions: 0,
    currentPosition: null,
    currentTx: null,
    loading: false,
    error: null,
    retry: 0
  },
  mutations: {
    setTransactions (state, transactions) {
      state.transactions = transactions
    },
    setCurrentPage (state, page) {
      state.currentPage = page
    },
    setMaxTransactions (state, max) {
      state.maxTransactions = max
    },
    setCurrentPosition (state, pos) {
      state.currentPosition = pos
    },
    setCurrentTx (state, tx) {
      state.currentTx = tx
    },
    setLoading (state, loading) {
      state.loading = loading
    },
    setError (state, err) {
      state.error = err
    },
    setRetry (state, count) {
      state.retry = count
    }
  },
  actions: {
    async fetch ({commit, rootState, state, dispatch}) {
      dispatch('loading/setLoading', {loading: true, percentage: 10}, {root: true})
      try {
        const account = rootState.wallet.linkedAccount.account
        if (account !== null) {
          dispatch('loading/setLoading', {loading: true, percentage: 30}, {root: true})
          const data = await EosRpc.fetchAccountHistory({account, pos: state.currentPosition})
          if (data.actions.length > 0) {
            commit('setTransactions', data.actions)
            dispatch('loading/setLoading', {loading: true, percentage: 100}, {root: true})
          }
        }
      } catch (err) {
        commit('setTransactions', [])
        commit('setError', err.message)
      }
      commit('setLoading', false)
      dispatch('loading/done', {}, {root: true})
    },
    async next ({dispatch, commit, state}) {
      const tx = state.transactions.slice(0, 1).shift()
      const AccountActionSeq = Number(tx.account_action_seq)
      if (AccountActionSeq > 1) {
        commit('setCurrentPosition', AccountActionSeq - 1)
        commit('setCurrentPage', Number(state.currentPage + 1))
        dispatch('fetch')
      }
    },
    async prev ({dispatch, commit, state}) {
      if (state.currentPage > 1) {
        const tx = state.transactions.slice(-1).shift()
        commit('setCurrentPosition', Number(tx.account_action_seq + 21))
        commit('setCurrentPage', Number(state.currentPage - 1))
        dispatch('fetch')
      }
    },
    setCurrentTx ({commit}, tx) {
      commit('setCurrentTx', tx)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/wallet-transactions.js